import { ButtonCollection } from '../../../buttonCollection';
import type { MagazineActionsProps } from '../../types';
import { CREATIVE_ID } from 'hooks';

/**
 * Renders a set of call-to-action (CTA) buttons for the Magazine page, adapted to desktop and mobile devices.
 *
 * Depending on the CTA configuration, it conditionally renders:
 * - Primary and secondary CTAs for both desktop and mobile
 * - A special DownloadButton for software download links
 * - Tracking for external link clicks via `handleLinkOutTracking`
 *
 * @param {MagazineActionsProps} props - The props object.
 * @param ctaPrimaryDesktop - Primary CTA for desktop devices.
 * @param ctaPrimaryMobile - Primary CTA for mobile devices.
 * @param ctaSecondaryDesktop - Secondary CTA for desktop devices.
 * @param ctaSecondaryMobile - Secondary CTA for mobile devices.
 * @param constants - Constants passed to the DownloadButton.
 * @param device - The target device ('desktop' or 'mobile') to determine which CTAs to render.
 *
 * @returns A fragment containing rendered Button components.
 */
export function MagazineActions(props: MagazineActionsProps) {
  return <ButtonCollection {...props} creativeId={CREATIVE_ID.MAGAZINE} />;
}
